import { render, staticRenderFns } from "./PackagesSuccessBoughtModal.vue?vue&type=template&id=27847fb6&scoped=true"
import script from "./PackagesSuccessBoughtModal.vue?vue&type=script&lang=js"
export * from "./PackagesSuccessBoughtModal.vue?vue&type=script&lang=js"
import style0 from "./PackagesSuccessBoughtModal.vue?vue&type=style&index=0&id=27847fb6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27847fb6",
  null
  
)

export default component.exports